import { styled } from '@mui/material/styles';

export const Form = styled('form')({});
